// extracted by mini-css-extract-plugin
var _1 = "l4wMJ";
var _2 = "R_F2a";
var _3 = "wtZKQ";
var _4 = "SUZPm";
var _5 = "FmK31";
var _6 = "UBePO";
var _7 = "azDMI";
var _8 = "w3tyf";
var _9 = "wC0NC";
var _a = "gd1N8";
var _b = "fDpGj";
var _c = "FDs0s";
export { _1 as "aqua", _2 as "dark", _3 as "darkest", _4 as "gold", _5 as "light", _6 as "lightest", _7 as "mint", _8 as "neutral", _9 as "normal", _a as "ruby", _b as "teal", _c as "violet" }
